import { Button, Grid } from '@mui/material';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { SeatAreaContext } from '../../../../../../contexts/SeatAreaContext';
import { WebSocketContext } from '../../../../../../contexts/WebSocketContext';
import { useBetSource } from '../../../../../../hooks/useBetSource';
import { CMDPsMakeDecision } from '../../../../../../models/cmd/live';
import { Decision } from '../../../../../../models/games/blackjack/enums/Decision';
import { BaseTypography } from '../../../../../../components/common/baseText/BaseTypography';

export const HitDecisionButton = () => {
    const { t } = useTranslation();
    const betSource = useBetSource();
    const { sendCommand } = useContext(WebSocketContext);
    const { setShowDecision, gameId } = useContext(SeatAreaContext);
    return (
        <Button
            className="blackjack-decision-button"
            onClick={() => {
                const command = new CMDPsMakeDecision();
                command.GameID = gameId;
                command.BetSource = betSource;
                command.Decision = Decision.Hit;

                sendCommand(command);
                setShowDecision(false);
            }}
        >
            <Grid>
                <svg
                    width="57"
                    height="56"
                    viewBox="0 0 57 56"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect
                        x="0.399902"
                        width="56"
                        height="56"
                        rx="28"
                        fill="#34724F"
                    />
                    <g filter="url(#filter0_d_246_291821)">
                        <path
                            d="M36.8959 29.128V26.704H29.5999V19.408H27.1759V26.704H19.8799V29.128H27.1759V36.424H29.5999V29.128H36.8959Z"
                            fill="white"
                        />
                    </g>
                    <defs>
                        <filter
                            id="filter0_d_246_291821"
                            x="15.8799"
                            y="15.4082"
                            width="25.0161"
                            height="25.0156"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB"
                        >
                            <feFlood
                                floodOpacity="0"
                                result="BackgroundImageFix"
                            />
                            <feColorMatrix
                                in="SourceAlpha"
                                type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                result="hardAlpha"
                            />
                            <feOffset />
                            <feGaussianBlur stdDeviation="2" />
                            <feComposite in2="hardAlpha" operator="out" />
                            <feColorMatrix
                                type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0"
                            />
                            <feBlend
                                mode="normal"
                                in2="BackgroundImageFix"
                                result="effect1_dropShadow_246_291821"
                            />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_dropShadow_246_291821"
                                result="shape"
                            />
                        </filter>
                    </defs>
                </svg>
                <BaseTypography
                    color={'white'}
                    fontSize={18}
                    resize={{ direction: 'horizontal', value: '80px' }}
                >
                    {t('blackjack.decision.hit')}
                </BaseTypography>
            </Grid>
        </Button>
    );
};
